export const getLastRecorderAudioChunk = async (
	audioBlob: Blob,
	lastProcessedPosition: number,
	sampleRate: number = 24000,
): Promise<{ audioBuffer: AudioBuffer | null; newAudioEndPosition: number }> => {
	const arrayBuffer = await audioBlob.arrayBuffer();
	const audioContext = new AudioContext({ sampleRate });

	try {
		const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
		const totalSamples = audioBuffer.length;
		const newSamples = totalSamples - lastProcessedPosition;

		if (newSamples <= 0) {
			await audioContext.close();
			return { audioBuffer: null, newAudioEndPosition: 0 };
		}

		const newAudioStart = lastProcessedPosition;
		const newAudioEndPosition = totalSamples;
		const newAudioLength = newAudioEndPosition - newAudioStart;

		const newAudioBuffer = audioContext.createBuffer(
			audioBuffer.numberOfChannels,
			newAudioLength,
			audioBuffer.sampleRate,
		);

		// Copy audio data from the specified range for each channel
		for (let channel = 0; channel < audioBuffer.numberOfChannels; channel++) {
			const channelData = audioBuffer.getChannelData(channel);
			const newChannelData = newAudioBuffer.getChannelData(channel);
			newChannelData.set(channelData.slice(newAudioStart, newAudioEndPosition));
		}

		await audioContext.close();
		return { audioBuffer: newAudioBuffer, newAudioEndPosition };
	} catch (error) {
		await audioContext.close();
		throw error;
	}
};
